var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeViewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6-4h30v30H-6z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#1557bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h4v4h-4zM11.5 19.5h4v4h-4zM11.5 5.5h4v4h-4zM11.5 12.5h4v4h-4zM3 5v3h8.123M3 8v6h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12v9h8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeViewActive);
export default __webpack_public_path__ + "static/media/tree-view-active.dcb993acb65ae64650b2dc03842d7f06.svg";
export { ForwardRef as ReactComponent };